import { Player } from './Player';

export class PlayerMetadata {
  type: string = 'Player';
  connectionId?: string;
  playerName?: string = "";
  playerId?: string = "";
  playerPosition: {
      x: number,
      y: number,
  } = {x:0, y:0};
  lastUpdated: number = Date.now();
  levelName?: string = "";

  constructor(id: string) {
    this.playerId = id;
  }
  update(player: Player) {
    if (
      !(
        this.playerPosition.x === player.x &&
        this.playerPosition.y === player.y
      )
    ) {
      this.playerPosition.x = player.x;
      this.playerPosition.y = player.y;
      this.lastUpdated = Date.now();
      this.levelName = player.scene.scene.key;
      return true;
    }
    return false;
  }
}
